import { BaseListing } from 'craftable';

export default {
	mixins: [BaseListing],
        created() {
            this.$cookie.set('per_page',500, { secure: true, sameSite: "lax" });
        },
                
        methods: {
            getTableScrollableHeight: function getTableScrollableHeight(customSpacing, timeout) 
            {
                var _this = this;
                
                if(!customSpacing)
                {
                    customSpacing = 90;
                }
                
                if(timeout!= -1)
                {
                    if(!timeout)
                    {
                        timeout = 100;
                    }

                    setTimeout(function() {
                        _this.getTableScrollableHeight(customSpacing,-1);
                    },timeout);
                    return;
                }
                
                if(document.querySelector('.table-scrollable'))
                {
                    var spacing = (customSpacing ? customSpacing : 90);
                    var offTop = document.querySelector('.table-scrollable').offsetTop;
                    var height = window.innerHeight - offTop - spacing;

                    if(timeout==-1)
                        document.querySelector('.table-scrollable').style.height = height+"px";
                }
                
                return height+"px";
            }
        }
};


// WEBPACK FOOTER //
// ./resources/assets/admin/js/app-components/Listing/AppListing.js